import { z } from "@/zod";
import { dateTime } from "@/schemas/commonFields/dateTime";

export const contestAgreement = z.object({
  id: z.string(),
  contractor_id: z.string(),
  contractor_user_id: z.string().optional(),
  contractor_user_ref_number: z.string().optional(),
  contractor_full_name: z.string().optional(),
  contractor_personal_id_number: z.string().optional(),
  contractor_phone_number: z.string().optional(),
  contractor_email: z.string().optional(),
  period: z.string().optional(),
  agreement_company_name: z.string().optional(),
  agreement_start_date: z.string().optional(),
  agreement2_sent_at: dateTime.optional(),
  agreement2_sign_date: dateTime.optional(),
  agreement2_presentation_image_count: z.number().optional(),
  can_send_agreement2: z.boolean().optional(),
  payroll_type: z.string().optional(),
  payroll_version: z.string().optional(),
});

export const contestAgreementRead = contestAgreement.readonly();

const contestAgreementListBase = contestAgreement.omit({
  can_send_agreement2: true,
});

export const contestAgreementList = contestAgreementListBase.readonly();

export const contestAgreementListRestricted = contestAgreementListBase
  .omit({
    agreement2_presentation_image_count: true,
  })
  .readonly();

export const contestAgreementListFull = contestAgreementListBase
  .extend({
    payroll_id_suffix: z.string().optional(),
  })
  .readonly();

export const contestAgreementListFullRestricted = contestAgreementListBase
  .omit({
    agreement2_presentation_image_count: true,
  })
  .extend({
    payroll_id_suffix: z.string().optional(),
  })
  .readonly();

export const contestAgreementFileType = z.enum([
  "agreement",
  "contest_presentation",
  "presentation",
]);

export const contestAgreementFile = z.object({
  type: contestAgreementFileType,
  filename: z.string(),
  size: z.number(),
  presigned_url: z.string(),
  metadata: z.record(z.unknown()).optional(),
});

export const contestAgreementDetail = contestAgreement.extend({
  payroll_id: z.string().optional(),
  files: z.array(contestAgreementFile),
});
